import React, { useRef, useEffect, useCallback } from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Typography } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import { fabric } from 'fabric';

const CANVAS_WIDTH = 800;
const CANVAS_HEIGHT = 800;

/**
 * Base template for the Table Set Up canvas.
 * Edit this object to define the default layout (rectangles, text, lines, etc.)
 * that users see when they open the canvas. They will add their own content
 * on top using the toolbar (pencil, text, shapes).
 *
 * Format: Fabric.js JSON — "version" (e.g. "5.3.0") and "objects" (array of
 * Fabric object definitions). Common types: "rect", "line", "i-text", "text".
 * Use left, top, width, height, stroke, fill, fontSize, etc. originX/originY
 * "left"/"top" are recommended for predictable positioning.
 */
export const BASE_TEMPLATE = {"version":"5.3.0","objects":[{"type":"rect","version":"5.3.0","originX":"left","originY":"top","left":138,"top":-0.84,"width":484,"height":59,"fill":"transparent","stroke":"#000","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":0.82,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"i-text","version":"5.3.0","originX":"left","originY":"top","left":327,"top":13.16,"width":103.09,"height":18.08,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"fontFamily":"Times New Roman","fontWeight":"normal","fontSize":16,"text":"W I N D O W S","underline":false,"overline":false,"linethrough":false,"textAlign":"left","fontStyle":"normal","lineHeight":1.16,"textBackgroundColor":"","charSpacing":0,"styles":[],"direction":"ltr","path":null,"pathStartOffset":0,"pathSide":"left","pathAlign":"baseline"},{"type":"rect","version":"5.3.0","originX":"left","originY":"top","left":759,"top":127.16,"width":39,"height":515,"fill":"transparent","stroke":"#000","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"i-text","version":"5.3.0","originX":"left","originY":"top","left":790.88,"top":324.36,"width":96.02,"height":18.08,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":90.99,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"fontFamily":"Times New Roman","fontWeight":"normal","fontSize":16,"text":"M I R R O R S","underline":false,"overline":false,"linethrough":false,"textAlign":"left","fontStyle":"normal","lineHeight":1.16,"textBackgroundColor":"","charSpacing":0,"styles":[],"direction":"ltr","path":null,"pathStartOffset":0,"pathSide":"left","pathAlign":"baseline"},{"type":"rect","version":"5.3.0","originX":"left","originY":"top","left":35,"top":770.16,"width":126,"height":34,"fill":"transparent","stroke":"#000","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"rect","version":"5.3.0","originX":"left","originY":"top","left":630,"top":768.16,"width":122,"height":38,"fill":"transparent","stroke":"#000","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"i-text","version":"5.3.0","originX":"left","originY":"top","left":56,"top":777.16,"width":85.33,"height":18.08,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"fontFamily":"Times New Roman","fontWeight":"normal","fontSize":16,"text":"ENTRANCE","underline":false,"overline":false,"linethrough":false,"textAlign":"left","fontStyle":"normal","lineHeight":1.16,"textBackgroundColor":"","charSpacing":0,"styles":[],"direction":"ltr","path":null,"pathStartOffset":0,"pathSide":"left","pathAlign":"baseline"},{"type":"i-text","version":"5.3.0","originX":"left","originY":"top","left":648,"top":775.16,"width":85.33,"height":18.08,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"fontFamily":"Times New Roman","fontWeight":"normal","fontSize":16,"text":"ENTRANCE","underline":false,"overline":false,"linethrough":false,"textAlign":"left","fontStyle":"normal","lineHeight":1.16,"textBackgroundColor":"","charSpacing":0,"styles":[],"direction":"ltr","path":null,"pathStartOffset":0,"pathSide":"left","pathAlign":"baseline"},{"type":"rect","version":"5.3.0","originX":"left","originY":"top","left":236,"top":752.16,"width":322,"height":35,"fill":"transparent","stroke":"#000","strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"rx":0,"ry":0},{"type":"i-text","version":"5.3.0","originX":"left","originY":"top","left":339,"top":760.16,"width":115.12,"height":18.08,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeUniform":false,"strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"backgroundColor":"","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","skewX":0,"skewY":0,"fontFamily":"Times New Roman","fontWeight":"normal","fontSize":16,"text":"CHALK BOARD","underline":false,"overline":false,"linethrough":false,"textAlign":"left","fontStyle":"normal","lineHeight":1.16,"textBackgroundColor":"","charSpacing":0,"styles":[],"direction":"ltr","path":null,"pathStartOffset":0,"pathSide":"left","pathAlign":"baseline"}]};

/**
 * Renders Fabric.js canvas JSON to a PNG data URL for use in print or export.
 * Returns null if jsonStr is empty, invalid, or rendering fails.
 */
export function fabricJsonToDataUrl(jsonStr: string): Promise<string | null> {
  if (!jsonStr || !jsonStr.trim()) return Promise.resolve(null);
  let data: Record<string, unknown>;
  try {
    data = JSON.parse(jsonStr);
  } catch {
    return Promise.resolve(null);
  }
  if (!data || typeof data !== 'object' || !Array.isArray(data.objects)) {
    return Promise.resolve(null);
  }
  const width = (data.width as number) || CANVAS_WIDTH;
  const height = (data.height as number) || CANVAS_HEIGHT;
  const el = document.createElement('canvas');
  el.width = width;
  el.height = height;
  const canvas = new fabric.Canvas(el, {
    width,
    height,
    backgroundColor: '#ffffff',
    selection: false,
  });
  return new Promise((resolve) => {
    canvas.loadFromJSON(data, () => {
      try {
        const dataUrl = canvas.toDataURL('image/png');
        canvas.dispose();
        resolve(dataUrl);
      } catch {
        canvas.dispose();
        resolve(null);
      }
    });
  });
}

type Tool = 'select' | 'pencil' | 'text' | 'eraser' | 'rect';

interface TableSetUpCanvasProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const TableSetUpCanvas: React.FC<TableSetUpCanvasProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const canvasRef = useRef<fabric.Canvas | null>(null);
  const lastValueRef = useRef<string>(value);
  const [tool, setTool] = React.useState<Tool>('select');
  const rectStartRef = useRef<{ x: number; y: number } | null>(null);
  const rectShapeRef = useRef<fabric.Rect | null>(null);

  const serialize = useCallback(() => {
    if (!canvasRef.current) return '';
    try {
      return JSON.stringify(canvasRef.current.toJSON());
    } catch {
      return '';
    }
  }, []);

  const notifyChange = useCallback(() => {
    const json = serialize();
    if (json) {
      lastValueRef.current = json;
      onChange(json);
    }
  }, [onChange, serialize]);

  const loadCanvas = useCallback(
    (jsonStr: string, onLoaded?: () => void) => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const load = (data: string | Record<string, unknown>, afterLoad?: () => void) => {
        canvas.loadFromJSON(data, () => {
          canvas.renderAll();
          afterLoad?.();
        });
      };

      if (jsonStr && jsonStr.trim()) {
        try {
          const data = JSON.parse(jsonStr);
          if (data && typeof data === 'object' && Array.isArray(data.objects)) {
            load(data, () => {
              lastValueRef.current = jsonStr;
              onLoaded?.();
            });
            return;
          }
        } catch {
          // not valid fabric json
        }
        // Plain text from older forms: show as text on base template
        const withText = {
          ...BASE_TEMPLATE,
          objects: [
            ...(BASE_TEMPLATE.objects as object[]),
            {
              type: 'i-text',
              text: jsonStr,
              left: 20,
              top: 50,
              fontSize: 14,
              fill: '#000',
              originX: 'left',
              originY: 'top',
            },
          ],
        };
        load(withText as Record<string, unknown>, () => {
          lastValueRef.current = serialize();
          onChange(lastValueRef.current);
          onLoaded?.();
        });
        return;
      }
      load(BASE_TEMPLATE as Record<string, unknown>, () => {
        lastValueRef.current = serialize();
        onChange(lastValueRef.current);
        onLoaded?.();
      });
    },
    [onChange, serialize]
  );

  // Init canvas and load value (run on mount and when disabled changes only)
  useEffect(() => {
    const container = containerRef.current;
    if (!container || disabled) return;

    const el = document.createElement('canvas');
    el.width = CANVAS_WIDTH;
    el.height = CANVAS_HEIGHT;
    container.innerHTML = '';
    container.appendChild(el);

    const canvas = new fabric.Canvas(el, {
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT,
      backgroundColor: '#ffffff',
      selection: true,
      isDrawingMode: false,
    });

    canvasRef.current = canvas;

    canvas.on('object:modified', () => notifyChange());
    canvas.on('path:created', () => notifyChange());

    // Delete selected object(s) on Delete or Backspace
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Delete' && e.key !== 'Backspace') return;
      const target = canvas.getActiveObject();
      if (!target) return;
      if ((target as fabric.Object).type === 'activeSelection') {
        (target as fabric.ActiveSelection).getObjects().forEach((obj) => canvas.remove(obj));
      } else {
        canvas.remove(target);
      }
      canvas.discardActiveObject();
      canvas.renderAll();
      notifyChange();
      e.preventDefault();
    };
    const wrapper = (canvas as fabric.Canvas & { wrapperEl?: HTMLElement }).wrapperEl || container;
    if (wrapper) {
      wrapper.addEventListener('keydown', onKeyDown);
      wrapper.setAttribute('tabIndex', '0');
      (wrapper as HTMLElement).style.outline = 'none';
    }

    loadCanvas(value);

    return () => {
      if (wrapper) wrapper.removeEventListener('keydown', onKeyDown);
      canvas.off('object:modified');
      canvas.off('path:created');
      canvas.dispose();
      canvasRef.current = null;
      container.innerHTML = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- init only on mount/disabled
  }, [disabled]);

  // When value changes from parent (e.g. form load), load it if different from what we last sent
  useEffect(() => {
    if (!canvasRef.current || value === lastValueRef.current) return;
    lastValueRef.current = value;
    loadCanvas(value);
  }, [value, loadCanvas]);

  // Apply current tool
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || disabled) return;

    canvas.isDrawingMode = tool === 'pencil' || tool === 'eraser';
    canvas.selection = tool === 'select';

    if (canvas.isDrawingMode && canvas.freeDrawingBrush) {
      if (tool === 'eraser') {
        canvas.freeDrawingBrush.color = '#ffffff';
        canvas.freeDrawingBrush.width = 20;
      } else {
        canvas.freeDrawingBrush.color = '#000000';
        canvas.freeDrawingBrush.width = 2;
      }
    }

    if (tool === 'rect') {
      rectStartRef.current = null;
      rectShapeRef.current = null;
    }
  }, [tool, disabled]);

  // Rectangle drawing: mouse down -> start rect, mouse move -> resize, mouse up -> add
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || tool !== 'rect' || disabled) return;

    const onMouseDown = (opt: fabric.IEvent) => {
      if (opt.target) return;
      const p = canvas.getPointer(opt.e);
      if (!p) return;
      rectStartRef.current = { x: p.x, y: p.y };
      const rect = new fabric.Rect({
        left: p.x,
        top: p.y,
        width: 0,
        height: 0,
        stroke: '#000',
        strokeWidth: 1,
        fill: 'transparent',
        originX: 'left',
        originY: 'top',
      });
      rectShapeRef.current = rect;
      canvas.add(rect);
    };

    const onMouseMove = (opt: fabric.IEvent) => {
      const start = rectStartRef.current;
      const rect = rectShapeRef.current;
      if (!start || !rect) return;
      const p = canvas.getPointer(opt.e);
      if (!p) return;
      const w = p.x - start.x;
      const h = p.y - start.y;
      rect.set({
        width: Math.abs(w),
        height: Math.abs(h),
        left: w < 0 ? p.x : start.x,
        top: h < 0 ? p.y : start.y,
      });
      rect.setCoords();
      canvas.renderAll();
    };

    const onMouseUp = () => {
      const rect = rectShapeRef.current;
      rectStartRef.current = null;
      rectShapeRef.current = null;
      if (rect && rect.width! < 3 && rect.height! < 3) {
        canvas.remove(rect);
      } else if (rect) {
        notifyChange();
      }
      canvas.renderAll();
    };

    canvas.on('mouse:down', onMouseDown);
    canvas.on('mouse:move', onMouseMove);
    canvas.on('mouse:up', onMouseUp);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.off('mouse:move', onMouseMove);
      canvas.off('mouse:up', onMouseUp);
    };
  }, [tool, disabled, notifyChange]);

  // Text tool: one shot add text on click
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || tool !== 'text' || disabled) return;

    const onMouseDown = (opt: fabric.IEvent) => {
      if (opt.target) return;
      const p = canvas.getPointer(opt.e);
      if (!p) return;
      const text = new fabric.IText('Text', {
        left: p.x,
        top: p.y,
        fontSize: 16,
        originX: 'left',
        originY: 'top',
      });
      canvas.add(text);
      canvas.setActiveObject(text);
      text.enterEditing();
      text.selectAll();
      canvas.renderAll();
      notifyChange();
      setTool('select');
    };

    canvas.on('mouse:down', onMouseDown);
    return () => canvas.off('mouse:down', onMouseDown);
  }, [tool, disabled, notifyChange]);

  const handleToolChange = (_: React.MouseEvent<HTMLElement>, newTool: Tool | null) => {
    if (newTool !== null) setTool(newTool);
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        Table Set Up
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        Select an element, then press Delete or Backspace to remove it.
      </Typography>
      <ToggleButtonGroup
        value={tool}
        exclusive
        onChange={handleToolChange}
        aria-label="drawing tool"
        size="small"
        sx={{ mb: 1 }}
        disabled={disabled}
      >
        <ToggleButton value="select" aria-label="select / move">
          <OpenWithIcon />
        </ToggleButton>
        <ToggleButton value="pencil" aria-label="pencil">
          <CreateIcon />
        </ToggleButton>
        <ToggleButton value="text" aria-label="text">
          <TextFieldsIcon />
        </ToggleButton>
        <ToggleButton value="eraser" aria-label="eraser">
          <DeleteOutlineIcon />
        </ToggleButton>
        <ToggleButton value="rect" aria-label="rectangle">
          <CropSquareIcon />
        </ToggleButton>
      </ToggleButtonGroup>
      <Box
        ref={containerRef}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          width: CANVAS_WIDTH,
          maxWidth: '100%',
        }}
      />
    </Box>
  );
};
